module.exports = __webpack_public_path__ + "img/0Q3A4704_L_BlackMatted.5af87c41.jpg";